<script>
    import { info, credits } from '../store';
    import { numberFormatter, reset, numberFormatterNoDecimal } from '../functions';
    import _ from 'lodash';

    import Step1 from './Step1.svelte';
    import Step2 from './Step2.svelte';
    import Step4 from './Step4.svelte';

    export let step;
    export let stepComponent;

    $: $credits, calculateSpendingHoursInAdvance();

    function calculateSpendingHoursInAdvance () {
        $info.spending_hours_in_advance = _.sumBy($credits, 'loan_amount') / ($info.income / $info.hours_month);
    }

    function first () {
        step = 1;
        stepComponent = Step1;
    }

    function prev () {
        step = 2;
        stepComponent = Step2;
    }

    function next () {
        step = 4;
        stepComponent = Step4;
    }

    function resetApp () {
        reset();
        $credits = [
            {
                name: '',
                loan_amount: '',
                duration: '',
                interest_rate: '',
                interest_rate_annually: 0,
                monthly_payment: 0,
                amount_paid: 0,
                interest_paid: 0,
            }
        ];
        $info = { name: '', income: 0, hours_month: 168, result_income_hour: 0, level_indebtedness: 0, amount_money_paid: 0, spending_hours_in_advance: 0, payment_option_credit: null };
        step = 1;
        stepComponent = Step1;
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-3">
        <div class="text-center color-mov mb-4">
            <h2>Situația actuală a datoriilor tale</h2>
        </div>

        <div class="bloc-with-number">
            <div class="nr">1</div>
            <div><strong>{$credits.length}</strong> credite</div>
        </div>
        <div class="bloc-with-number">
            <div class="nr">2</div>
            <div>Ai <strong>{numberFormatter(_.sumBy($credits, 'loan_amount'))}</strong> de înapoiat, adică ai vândut în avans <strong>{numberFormatterNoDecimal($info.spending_hours_in_advance)}</strong> ore din viața ta lucrătoare</div>
        </div>
        <div class="bloc-with-number">
            <div class="nr">3</div>
            <div><strong>{numberFormatter(_.sumBy($credits, 'monthly_payment'))}</strong> de plată lunar</div>
        </div>
        <div class="bloc-with-number">
            <div class="nr">4</div>
            <div>Vei plăti în total <strong>{numberFormatter(_.sumBy($credits, 'amount_paid'))} </strong> din care <strong>{numberFormatter(_.sumBy($credits, 'interest_paid'))}</strong> dobânda</div>
        </div>

        <div class="text-center color-orange mb-4">
            <h2>Ai de făcut o alegere</h2>
        </div>

        <div class="row align-items-center justify-content-center ">
            <div class="col-sm-auto mb-3 text-center">
                <button class="buton bt-next-step" on:click="{resetApp}">PLĂTESC CA PÂNĂ ACUM</button>
            </div>
            <div class="col-sm-auto mb-3 text-center">
                <button class="buton bt-next-step" on:click="{next}">PLĂTESC ANTICIPAT</button>
            </div>
        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{prev}">
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
